import React from 'react';

class TopifyAlertsTemplate extends React.Component {
	render() {
		let closeX = <span className='s-alert-close' onClick={ this.props.handleClose } />;

		return (
			<div className={ this.props.classNames } id={ this.props.id } style={ this.props.styles }>
				<div className="s-alert-box-inner" onClick={ this.props.handleClose }>
					{ closeX }
					{ this.props.message }
				</div>
			</div>
		)
	}
}

export default TopifyAlertsTemplate;


// WEBPACK FOOTER //
// ./src/components/alerts/alertsTemplate.js